import { CHIP_FIELD_CONSTANTS } from './chip-field-constants';
import { getActiveElement } from 'shadow-utils';
var ChipFieldFoundation = /** @class */ (function () {
    function ChipFieldFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._floatLabelType = 'auto';
        this._labelSlotListener = function () { return _this._onLabelSlotChanged(); };
        this._memberSlotListener = function () { return _this._onMemberSlotChanged(); };
        this._focusInput = function () { return _this._adapter.focusInput(); };
        this._handleInputBlur = function (event) { return _this._onInputBlur(event); };
        this._handleInputFocus = function () { return _this._onInputFocus(); };
        this._handleRootKeyDown = function (event) { return _this._onRootKeyDown(event); };
        this._handleKeyDown = function (event) { return _this._onKeyDown(event); };
        this._inputAttributeListener = function (name, value) { return _this._onInputAttributeChange(name, value); };
        this._adapter.addLabelSlotListener(this._labelSlotListener);
        this._adapter.addMemberSlotListener(this._memberSlotListener);
    }
    ChipFieldFoundation.prototype.connect = function () {
        this._adapter.addRootEventListener('click', this._focusInput);
        this._adapter.addRootEventListener('keydown', this._handleRootKeyDown);
        this._adapter.addInputEventListener('keydown', this._handleKeyDown);
        this._adapter.addInputEventListener('blur', this._handleInputBlur);
        this._adapter.addInputEventListener('focus', this._handleInputFocus);
        this._adapter.setInputAttributeObserver(this._inputAttributeListener);
        this._notchedOutline = this._adapter.initializeNotchedOutline();
        this._adapter.ensureSlottedLabel();
        if (this._adapter.hasPlaceholder()) {
            this._floatLabelType = 'always';
        }
        this._handleDisabledState();
        this._initializeLabel();
    };
    ChipFieldFoundation.prototype.disconnect = function () {
        this._adapter.removeLabelSlotListener(this._labelSlotListener);
        this._adapter.removeMemberSlotListener(this._memberSlotListener);
        this._adapter.removeRootEventListener('click', this._focusInput);
        this._adapter.removeRootEventListener('keydown', this._handleRootKeyDown);
        this._adapter.removeInputEventListener('keydown', this._handleKeyDown);
        this._adapter.removeInputEventListener('blur', this._handleInputBlur);
        this._adapter.removeInputEventListener('focus', this._handleInputFocus);
        if (this._floatingLabel) {
            this._floatingLabel.destroy();
            this._floatingLabel = undefined;
        }
        if (this._notchedOutline) {
            this._notchedOutline.destroy();
        }
    };
    ChipFieldFoundation.prototype.floatLabel = function (value) {
        if (!value && this._floatLabelType === 'always') {
            if (this._floatingLabel) {
                this._floatingLabel.float(true);
                if (this._notchedOutline) {
                    this._notch();
                }
            }
            this._adapter.setHostAttribute(CHIP_FIELD_CONSTANTS.attributes.HOST_LABEL_FLOATING, '');
            return;
        }
        if (this._floatingLabel) {
            this._floatingLabel.float(value);
            if (value) {
                this._adapter.setInputClass(CHIP_FIELD_CONSTANTS.classes.INPUT_FOCUSED);
                this._adapter.setHostAttribute(CHIP_FIELD_CONSTANTS.attributes.HOST_LABEL_FLOATING, '');
            }
            else {
                this._adapter.removeInputClass(CHIP_FIELD_CONSTANTS.classes.INPUT_FOCUSED);
                this._adapter.removeHostAttribute(CHIP_FIELD_CONSTANTS.attributes.HOST_LABEL_FLOATING);
            }
            if (this._notchedOutline) {
                if (value) {
                    this._notch();
                }
                else {
                    this._notchedOutline.closeNotch();
                }
            }
        }
    };
    ChipFieldFoundation.prototype._onInputFocus = function () {
        this._adapter.addRootClass(CHIP_FIELD_CONSTANTS.classes.FOCUSED);
        this._adapter.addLabelClass(CHIP_FIELD_CONSTANTS.classes.LABEL_FOCUSED);
        this.floatLabel(true);
    };
    ChipFieldFoundation.prototype._onInputBlur = function (event) {
        var input = event.target;
        input.value = '';
        this._adapter.removeRootClass(CHIP_FIELD_CONSTANTS.classes.FOCUSED);
        this._adapter.removeLabelClass(CHIP_FIELD_CONSTANTS.classes.LABEL_FOCUSED);
        if (!this._adapter.hasValue()) {
            this.floatLabel(false);
        }
    };
    ChipFieldFoundation.prototype._onRootKeyDown = function (event) {
        if (this._adapter.inputHasContent()) {
            return;
        }
        switch (event.key) {
            case 'Right':
            case 'ArrowRight':
                this._focusNextMember();
                break;
            case 'Left':
            case 'ArrowLeft':
                this._focusPreviousMember();
                break;
            case 'Backspace':
            case 'Delete':
            case 'Del':
                this._removeMember();
                break;
            default:
                break;
        }
    };
    ChipFieldFoundation.prototype._onKeyDown = function (event) {
        var input = event.target;
        switch (event.key) {
            case 'Enter':
                this._addMember(input);
                break;
            case 'Esc':
            case 'Escape':
            case 'Tab':
                input.value = '';
                break;
            default:
                break;
        }
    };
    ChipFieldFoundation.prototype._focusNextMember = function () {
        var members = this._adapter.getSlottedMemberElements();
        if (members.length < 1 || this._adapter.inputHasFocus()) {
            return;
        }
        for (var i = 0; i < members.length; i++) {
            var member = members.item(i);
            var nextMember = members.item(i + 1);
            if (this._memberIsActive(member)) {
                if (nextMember) {
                    nextMember.focus();
                    break;
                }
                else {
                    this._adapter.focusInput();
                }
            }
        }
    };
    ChipFieldFoundation.prototype._focusPreviousMember = function () {
        var members = this._adapter.getSlottedMemberElements();
        if (members.length < 1) {
            return;
        }
        if (this._adapter.inputHasFocus()) {
            members[members.length - 1].focus();
            return;
        }
        for (var i = 0; i < members.length; i++) {
            var previousMember = members.item(i - 1);
            var member = members.item(i);
            if (this._memberIsActive(member) && previousMember) {
                previousMember.focus();
                break;
            }
        }
    };
    ChipFieldFoundation.prototype._memberIsActive = function (ele) {
        return getActiveElement() === ele || ele.hasAttribute('focused');
    };
    ChipFieldFoundation.prototype._getActiveMember = function () {
        var members = this._adapter.getSlottedMemberElements();
        for (var i = 0; i < members.length; i++) {
            var member = members.item(i);
            if (this._memberIsActive(member)) {
                return member;
            }
        }
        return null;
    };
    ChipFieldFoundation.prototype._addMember = function (input) {
        var cleanInputValue = input.value.trim();
        if (cleanInputValue && cleanInputValue.length > 0) {
            this._adapter.emitHostEvent(CHIP_FIELD_CONSTANTS.events.MEMBER_ADDED, cleanInputValue);
        }
        input.value = '';
    };
    ChipFieldFoundation.prototype._removeMember = function () {
        var memberToRemove = this._getActiveMember();
        if (!memberToRemove) {
            var members = this._adapter.getSlottedMemberElements();
            memberToRemove = members.item(members.length - 1);
        }
        if (!memberToRemove) {
            return;
        }
        this._focusNextMember();
        this._adapter.emitHostEvent(CHIP_FIELD_CONSTANTS.events.MEMBER_REMOVED, memberToRemove);
    };
    ChipFieldFoundation.prototype._onLabelSlotChanged = function () {
        this._initializeLabel();
    };
    ChipFieldFoundation.prototype._onMemberSlotChanged = function () {
        this.floatLabel(this._adapter.hasValue() || this._adapter.inputHasFocus());
        this._adapter.getSlottedMemberElements().forEach(function (x) { return x.tabIndex = -1; });
    };
    ChipFieldFoundation.prototype._initializeLabel = function () {
        if (this._floatingLabel) {
            this._floatingLabel.destroy();
        }
        if (this._adapter.hasLabel()) {
            this._floatingLabel = this._adapter.initializeFloatingLabel();
            this._adapter.ensureLabelOrder();
            this.floatLabel(this._adapter.hasValue());
        }
        else {
            this._adapter.removeHostAttribute(CHIP_FIELD_CONSTANTS.attributes.HOST_LABEL_FLOATING);
            this._floatingLabel = undefined;
            this._notch();
        }
    };
    ChipFieldFoundation.prototype._notch = function () {
        if (this._notchedOutline) {
            this._notchedOutline.notch(this._getLabelWidth());
        }
    };
    ChipFieldFoundation.prototype._getLabelWidth = function () {
        if (!this._floatingLabel) {
            return 0;
        }
        var width = (this._floatingLabel.getWidth() || 0) * CHIP_FIELD_CONSTANTS.numbers.FLOATING_LABEL_SCALE_FACTOR;
        if (!width) {
            var labelFont = this._adapter.getLabelFontMetrics();
            var fontSize = labelFont.fontSize * CHIP_FIELD_CONSTANTS.numbers.FLOATING_LABEL_SCALE_FACTOR;
            width = this._adapter.getLabelWidth(fontSize, labelFont.fontFamily);
        }
        return width;
    };
    ChipFieldFoundation.prototype._onInputAttributeChange = function (name, value) {
        this._handleDisabledState();
    };
    ChipFieldFoundation.prototype._handleDisabledState = function () {
        if (this._adapter.isDisabled()) {
            this._adapter.addRootClass(CHIP_FIELD_CONSTANTS.classes.DISABLED);
        }
        else {
            this._adapter.removeRootClass(CHIP_FIELD_CONSTANTS.classes.DISABLED);
        }
    };
    Object.defineProperty(ChipFieldFoundation.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (value) {
            if (this._required === value) {
                return;
            }
            this._required = value;
            if (this._required) {
                this._adapter.setHostAttribute(CHIP_FIELD_CONSTANTS.attributes.REQUIRED);
                this._adapter.addRootClass(CHIP_FIELD_CONSTANTS.classes.REQUIRED);
            }
            else {
                this._adapter.removeHostAttribute(CHIP_FIELD_CONSTANTS.attributes.REQUIRED);
                this._adapter.removeRootClass(CHIP_FIELD_CONSTANTS.classes.REQUIRED);
            }
            this._adapter.setLabelAsRequiredForSafari(this._required);
            this._initializeLabel();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipFieldFoundation.prototype, "invalid", {
        get: function () {
            return this._invalid;
        },
        set: function (value) {
            if (this._invalid === value) {
                return;
            }
            this._invalid = value;
            if (this._invalid) {
                this._adapter.setHostAttribute(CHIP_FIELD_CONSTANTS.attributes.INVALID);
                this._adapter.addRootClass(CHIP_FIELD_CONSTANTS.classes.INVALID);
            }
            else {
                this._adapter.removeHostAttribute(CHIP_FIELD_CONSTANTS.attributes.INVALID);
                this._adapter.removeRootClass(CHIP_FIELD_CONSTANTS.classes.INVALID);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipFieldFoundation.prototype, "floatLabelType", {
        get: function () {
            return this._floatLabelType;
        },
        set: function (value) {
            if (this._floatLabelType === value) {
                return;
            }
            this._floatLabelType = value;
            this.floatLabel(this._floatLabelType === 'always');
            this._adapter.setHostAttribute(CHIP_FIELD_CONSTANTS.attributes.FLOAT_LABEL_TYPE, this._floatLabelType);
        },
        enumerable: true,
        configurable: true
    });
    return ChipFieldFoundation;
}());
export { ChipFieldFoundation };
